module.exports = __webpack_public_path__ + "media/images/empty-proposal-model-8180f266da49b708a56f3ddc59acd3da.png";